import React from 'react';
import './footer.css';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/eco-logo.png';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="gy-4">
          <Col lg="4" md="6">
            <div className="footer__brand">
              <div className="logo d-flex align-items-center gap-2 mb-3">
                <img src={logo} alt="L'Habilleur Logo" width="26" height="26" style={{ width: '1.6rem', height: '1.6rem' }} />
                <span className="text-white fs-4 fw-bold m-0">L'HABILLEUR</span>
              </div>
              <p className="footer__text">
                Exclusive atelier offering timeless contemporary furniture and handcrafted home decor created for the discerning lifestyle.
              </p>
              <div className="footer__trust-badge">
                <i className="ri-shield-check-line"></i>
                <span>100% Authentic Handcrafted Quality</span>
              </div>
            </div>
          </Col>

          <Col lg="3" md="3" sm="6">
            <div className="footer__quick-links">
              <h4 className="quick__links-title">The House</h4>
              <ListGroup className="list">
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/about">The Atelier & Heritage</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/lookbook">Editorial Lookbook</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/services">Bespoke Interior Services</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/contact">Flagship Showrooms</Link>
                </ListGroupItem>
              </ListGroup>
            </div>
          </Col>

          <Col lg="2" md="3" sm="6">
            <div className="footer__quick-links">
              <h4 className="quick__links-title">Collections</h4>
              <ListGroup className="list">
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/shop?category=chair">Atelier Chairs</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/shop?category=sofa">Modern Sofas</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/shop?category=table">Tables & Consoles</Link>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0">
                  <Link to="/shop?category=lighting">Lighting & Decor</Link>
                </ListGroupItem>
              </ListGroup>
            </div>
          </Col>

          <Col lg="3" md="6">
            <div className="footer__quick-links">
              <h4 className="quick__links-title">Atelier Concierge</h4>
              <ListGroup className="footer__contact">
                <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-2">
                  <span><i className="ri-map-pin-2-line"></i></span>
                  <p className="m-0">11454 Cairo, Egypt &bull; Global Delivery</p>
                </ListGroupItem>

                <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-2">
                  <span><i className="ri-phone-line"></i></span>
                  <p className="m-0">+20 (2) 2123-4567</p>
                </ListGroupItem>

                <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-2">
                  <span><i className="ri-mail-line"></i></span>
                  <p className="m-0">concierge@lhabilleur.com</p>
                </ListGroupItem>
              </ListGroup>
            </div>
          </Col>
        </Row>

        <div className="footer__bottom">
          <p className="footer__copyright m-0">
            &copy; {year} L'HABILLEUR Atelier. All rights reserved. Crafted with passion.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;